const tabs = [
  {
    heading: "Account",
    children: [
      {
        label: "Personal Details",
      },
    ],
  },
  {
    heading: "Company",
    children: [
      {
        label: "Company Details",
      },
      {
        label: "Account Members",
      },
    ],
  },
];

const SettingsPage = () => {
  return <div></div>;
};

export default SettingsPage;
